/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetInstrumentLinksRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetInstrumentLinks.pb'
import {GetInstrumentLinksResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetInstrumentLinks.pb'


export const getInstrumentLinks = (request: GetInstrumentLinksRequest, options?: CashRequestOptions) => post<GetInstrumentLinksRequest, GetInstrumentLinksResponse>("/2.0/cash/get-instrument-links", request, {...options, rejectOnError: true })